import { Result } from "antd";
import { translate } from "shared/languages";

const NotFoundPage = () => {
  return <Result status="404" title="404" subTitle={translate("subtitle.not_found")}></Result>;
};
export default NotFoundPage;
